import { useMemo } from 'react';
import {
  ScreenSize,
  useIsMobile,
  useScreenSize
} from '~/context/common/DeviceContext';
import { useClientSide } from '~/hooks/common';

function calculateSpinnerHeight(isMobile: boolean, screenSize: ScreenSize) {
  const width = screenSize.width;
  const offset = isMobile ? 32 : 64;
  const widthWithOffset = Math.min(width - offset, 1736);
  const height = isMobile
    ? Math.max((widthWithOffset * 9) / 16, 193)
    : Math.min((widthWithOffset * 9) / 16, 976);

  return { height, width: widthWithOffset };
}

export default function useSpinnerSize() {
  const isClientSide = useClientSide();
  const isMobile = useIsMobile();
  const screenSize = useScreenSize();

  return useMemo(() => {
    if (!isClientSide) return { focus: 0, height: 0 };

    const { width, height } = calculateSpinnerHeight(isMobile, screenSize);

    return { width, height };
  }, [isClientSide, isMobile, screenSize]);
}
